import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Access token lives 15 min: on 401, refresh once (shared across concurrent calls) and retry.
const NO_RETRY = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/register", "/auth/forgot-password", "/auth/reset-password"];
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status !== 401 || !cfg || cfg._retried || NO_RETRY.some((p) => url.startsWith(p))) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(cfg);
    } catch (e) {
      error.authExpired = true;
      window.dispatchEvent(new Event("auth:expired"));
      // The app redirects to login; leave other callers pending so they don't surface errors.
      if (url !== "/auth/me") return new Promise(() => {});
      return Promise.reject(error);
    }
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
